const searchClient = algoliasearch(
  'JK7XQR4ORN',
  '915d3f76b3c5d24aff21e6a4e6700a0d'
);

function translateTexts() {
  const translations = {
    "Search result": "Risultato della ricerca",
    "Show filters": "Mostra filtri",
    "Sorted by": "Ordinato per",
    "Relevance": "Rilevanza",
    "out of": "di",
    "results found": "risultati trovati",
    "Search for products": "Cerca tra i prodotti"
  };

  const sortedBy = document.querySelector('.ais-sort span');
  if (sortedBy) {
    sortedBy.childNodes.forEach((node) => {
      if (node.nodeType === Node.TEXT_NODE && node.textContent.trim() === "Sorted by") {
        node.textContent = translations["Sorted by"];
      }
    });
  }

  const selectedOption = document.querySelector('.ais-SortBy-select option:checked');
  if (selectedOption && selectedOption.textContent.trim() === "Relevance") {
    selectedOption.textContent = translations["Rilevanza"];
  }

  const searchInput = document.querySelector('.ais-search-box-container input');
  if (searchInput && searchInput.placeholder === "Search for products") {
    searchInput.placeholder = "Cerca tra i prodotti";
  }

  document.querySelectorAll('.ais-range-slider--header, .ais-facet--header, .ais-header').forEach((el) => {
    if (el.textContent.trim().toLowerCase() === "secolo") {
      el.textContent = "Anno di pubblicazione";
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  translateTexts();
  const observer = new MutationObserver(() => {
    translateTexts();
  });
  observer.observe(document.body, { childList: true, subtree: true });
});

// Funzione di setup per i range slider (Da / A)
function setupRangeSlider(sliderIndex, sliderName, rangeKey, containerId) {
  const facets = document.querySelectorAll('.ais-RangeSlider');
  const facet = facets[sliderIndex];
  
  if (!facet) return;

  facet.style.visibility = 'hidden';
  facet.style.display = 'none';
  facet.style.position = 'relative';
  facet.style.zIndex = '0';

  const panelBody = facet.closest('.ais-Panel-body') || facet.parentElement;

  if (!panelBody.querySelector(`#${containerId}`)) {
    const lower = facet.querySelector('.rheostat-handle-lower');
    const upper = facet.querySelector('.rheostat-handle-upper');

    const minPossible = parseInt(lower?.getAttribute('aria-valuemin') || '', 10) || '';
    const maxPossible = parseInt(upper?.getAttribute('aria-valuemax') || '', 10) || '';
    const curMin = parseInt(lower?.getAttribute('aria-valuenow') || '', 10) || '';
    const curMax = parseInt(upper?.getAttribute('aria-valuenow') || '', 10) || '';

    panelBody.insertAdjacentHTML('beforeend', `
      <div id="${containerId}" style="margin-top: 10px;">
        <form style="display:flex;gap:8px;align-items:center;flex-wrap:wrap;">
          <label>Da 
            <input id="${sliderName}-min" type="number" inputmode="numeric" placeholder="${minPossible}" value="${curMin}" style="width:110px;">
          </label>
          <label>A 
            <input id="${sliderName}-max" type="number" inputmode="numeric" placeholder="${maxPossible}" value="${curMax}" style="width:110px;">
          </label>
        </form>
      </div>
    `);
  }

  const $min = panelBody.querySelector(`#${containerId} #${sliderName}-min`);
  const $max = panelBody.querySelector(`#${containerId} #${sliderName}-max`);

  const setQueryParam = (url, key, value) => {
    const u = new URL(url);
    if (value == null) u.searchParams.delete(key);
    else u.searchParams.set(key, value);
    return u.toString();
  };

  const pushRouterChange = (newUrl) => {
    history.pushState({}, '', newUrl);
    window.dispatchEvent(new PopStateEvent('popstate'));
    window.dispatchEvent(new Event('instantsearch:router:changed'));
  };

  const applyViaUrlRouter = (minVal, maxVal) => {
    const hasMin = minVal !== '' && !isNaN(Number(minVal));
    const hasMax = maxVal !== '' && !isNaN(Number(maxVal));
    const value = hasMin || hasMax ? `${hasMin ? Number(minVal) : ''}:${hasMax ? Number(maxVal) : ''}` : null;
    const nextUrl = setQueryParam(location.href, rangeKey, value);
    pushRouterChange(nextUrl);
  };

  let debounceTimer = null;
  const handleInputChange = () => {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      const minVal = $min.value.trim();
      const maxVal = $max.value.trim();
      applyViaUrlRouter(minVal, maxVal);
      debounceTimer = null;
    }, 100);
  };

  if ($min && !$min.dataset.bound) {
    $min.dataset.bound = '1';
    $min.addEventListener('input', handleInputChange);
    $min.addEventListener('change', handleInputChange);
  }

  if ($max && !$max.dataset.bound) {
    $max.dataset.bound = '1';
    $max.addEventListener('input', handleInputChange);
    $max.addEventListener('change', handleInputChange);
  }
}

function hideEbayCategories() {
  const selectors = ['.ais-Menu-item', '.ais-RefinementList-item', '.ais-HierarchicalMenu-item', '.ais-ToggleRefinement'];
  selectors.forEach(selector => {
    document.querySelectorAll(selector).forEach((item) => {
      const label = item.querySelector('.ais-Menu-label, .ais-RefinementList-label, .ais-HierarchicalMenu-label');
      const link = item.querySelector('a');
      const text = label?.textContent || link?.textContent || item.textContent;
      
      if (text && (text.toLowerCase().includes('ebay') || 
        text.toLowerCase().includes('category_default') ||
        ['SpedEbay1', 'SpedEbay2', 'SpedEbay3', 'SpedEbay4', 'SpedEbay5', 'import-csv'].some(val => text.includes(val)))) {
        item.style.display = 'none';
        item.remove();
      }
    });
  });
}

// Inizializzazione sicura
const interval = setInterval(() => {
  const rangeSliders = document.querySelectorAll('.ais-RangeSlider');
  const hits = document.querySelector('.ais-Hits, .ais-RefinementList');
  const headers = document.querySelectorAll('.ais-Menu.ais-facet');

  if (hits && rangeSliders.length > 0 && headers.length > 0) {
    clearInterval(interval);
    
    translateTexts();
    hideEbayCategories();
    
    setupRangeSlider(0, 'price', 'range[price]', 'prezzo-range');
    setupRangeSlider(1, 'annoedizione', 'range[meta.magento.annoedizione]', 'anno-range');

    document.querySelectorAll('.ais-hit--cart-button').forEach((btn) => {
      if (!btn.hasAttribute('data-original-text')) {
        btn.setAttribute('data-original-text', btn.textContent.trim());
      }
      if (btn.getAttribute('data-original-text').toLowerCase() === 'add to cart') {
        btn.textContent = 'Aggiungi Ora';
      }
    });

    headers.forEach((header) => {
      const content = header.querySelector('.ais-Menu-list');
      if (content && !header.dataset.clickBound) {
        header.dataset.clickBound = '1';
        const label = header.querySelector('.ais-Menu-label')?.textContent?.trim()?.toUpperCase();
        if (label && (label.includes("NUOVO") || label.includes("USATO"))) {
          content.style.display = 'block';
          header.classList.add('open');
        } else {
          content.style.display = 'none';
          header.addEventListener('click', () => {
            const open = content.style.display === 'block';
            content.style.display = open ? 'none' : 'block';
            header.classList.toggle('open');
          });
        }
      }
    });
  }
}, 300);

document.addEventListener('algolia.hooks.initialize', function () {
  algoliaShopify.hooks.registerHook('beforeInstantSearchProductTemplate', function (_defaultTemplate, hit, html, components, trackSearchAttribution) {
    const hitImage = algoliaShopify.helpers.renderImage(hit, 250);

    return html`
      <div
        class="ais-hit ais-product"
        data-algolia-index="${hit.index}"
        data-algolia-position="${hit.productPosition}"
        data-algolia-queryid="${hit.queryID}"
        data-algolia-objectid="${hit.objectID}"
        data-handle="${hit.handle}"
        data-variant-id="${hit.objectID}"
        onClick="${() => trackSearchAttribution(hit)}"
      >
        <img
          class="ais-hit--picture"
          src="${hitImage.src}"
          srcset="${hitImage.srcset}"
          sizes="${hitImage.sizes}"
          alt="${hit.title} - ${hit.variant_title}"
        />

        <div class="ais-hit--details">
          <div class="ais-hit--extra-info" style="margin-bottom:8px; font-size:13px; text-align:left; color:#555;">
            <div style="margin-bottom: 3px;"><b>Codice:</b> ${hit.sku || '-'}</div>
            <div style="margin-bottom: 3px;"><b>Autore:</b> ${hit.meta?.magento?.autori_nome || '-'}</div>
            <div style="margin-bottom: 3px;"><b>Titolo:</b> ${hit.title || '-'}</div>
            <div style="margin-bottom: 10px;"><b>Editore:</b> ${hit.meta?.magento?.editori_nome || '-'}</div>
          </div>

          <p class="ais-hit--price">
            <b>${algoliaShopify.helpers.displayPrice(hit, hit._distinct)}</b>
          </p>

          ${!hit._distinct && html`
            <form id="algolia-add-to-cart-${hit.objectID}" action="/cart/add" method="post" enctype="multipart/form-data" style="display:none;">
              <input type="hidden" name="id" value="${hit.objectID}" />
            </form>

            <p class="ais-hit--cart">
              ${hit.can_order ? html`
                <button
                  type="button"
                  class="ais-hit--cart-button"
                  data-form-id="algolia-add-to-cart-${hit.objectID}"
                  onclick="document.getElementById('algolia-add-to-cart-${hit.objectID}').submit();"
                >
                  ${algoliaShopify.translations.addToCart}
                </button>
              ` : html`
                <button class="ais-hit--cart-button ais-hit--cart-button__disabled" disabled>
                  ${algoliaShopify.translations.outOfStock}
                </button>
              `}
            </p>
          `}
        </div>
      </div>
    `;
  });
});

document.addEventListener('algolia.hooks.initialize', function () {
  algoliaShopify.hooks.registerHook('beforeInstantSearchFacetParamsOptions', function (params, facet) {
    if (facet.name === 'collections' || 
        facet.name === 'product_type' || 
        facet.name === 'tags' ||
        facet.title?.toLowerCase().includes('categor') ||
        facet.title?.toLowerCase().includes('collezione')) {
      
      return {
        ...params,
        transformItems(items) {
          return items.filter(item => 
            !item.label.toLowerCase().includes('ebay') &&
            !item.value.toLowerCase().includes('ebay') &&
            !item.label.toLowerCase().includes('category_default') &&
            !item.value.toLowerCase().includes('category_default')
          );
        }
      };
    }
    return params;
  });
});